import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

// general
import Home from "../views/Home.vue";
import LandingPage from "../views/LandingPage.vue";
import Forgot from "../views/Forgot.vue";
import Error from "../views/Error.vue";

// organizer
import {
  Auth,
  OrganizerViewController,
  Start,
  PollsPage,
  Manage,
} from "../views/organizer";

// voter
import { VotePage, VoterViewController, LogIn } from "../views/voter";

Vue.use(VueRouter);

const routes = [
  // general
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "",
        name: "LandingPage",
        component: LandingPage,
      },
      {
        path: "forgot",
        name: "Forgot",
        component: Forgot,
      },
    ],
  },
  // organizer
  {
    path: "/organizer",
    component: OrganizerViewController,
    children: [
      {
        path: "auth",
        name: "Auth",
        component: Auth,
      },
      {
        path: "polls",
        name: "PollsPage",
        component: PollsPage,
        meta: {
          authRequired: true,
          lgn: "lgn",
        },
        children: [
          {
            path: "start",
            name: "Start",
            component: Start,
          },
          {
            path: "create",
            name: "Create",
            component: Start,
          },
          {
            path: ":id",
            name: "Manage",
            component: Manage,
          },
        ],
      },
    ],
  },
  // voter
  {
    path: "/voter",
    name: "VoterViewController",
    component: VoterViewController,
    children: [
      {
        path: "login",
        name: "LogIn",
        component: LogIn,
      },
      {
        path: "vote/:id",
        name: "VotePage",
        component: VotePage,
        meta: {
          authRequired: true,
          lgn: "vtr",
        },
      },
    ],
  },
  // 404 error page
  {
    path: "/*",
    name: "Error",
    component: Error,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL,
});

/** ROUTE GUARDS */
router.beforeEach((to, from, next) => {
  store.state.auth.isValidated = !!localStorage.getItem("lgn");
  const isAuthenticated = store.getters.getAuthStatus;

  const userType = localStorage.getItem("lgn");
  const fallbackRoute = {
    name: userType == "vtr" ? "VoterViewController" : "PollsPage",
  };

  // going to a protected route
  if (to.matched.some((record) => record.meta.authRequired)) {
    if (isAuthenticated) {
      // authenticated
      if (
        to.matched.some(
          (record) => record.meta.lgn && record.meta.lgn !== userType
        )
      ) {
        // redirect to user route
        next({ ...fallbackRoute });
      } else if (["Auth", "LogIn"].includes(to.name)) {
        // if going to auth page again, redirect to user route
        next({ ...fallbackRoute });
      } else {
        // go to desired route
        next();
      }
    } else {
      // not authenticated
      if (
        to.matched.some((record) => record.meta.lgn && record.meta.lgn == "lgn")
      ) {
        // redirect to homepage
        next({ path: "/" });
      } else if (
        to.matched.some((record) => record.meta.lgn && record.meta.lgn == "vtr")
      ) {
        // go to voter login page
        localStorage.setItem("pid", to.params.id);
        next({ name: "LogIn" });
      }
    }
  } else {
    // restrict some routes after authentication
    if (
      ["Auth", "LogIn", "LandingPage", "Forgot"].includes(to.name) &&
      isAuthenticated
    ) {
      next({ ...fallbackRoute });
    } else {
      next();
    }
  }
});

export default router;
